<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>员工信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" disabled>
        <el-row>
          <el-col :span="11">
            <el-form-item label="姓名：">
              <el-input v-model="employeeData.employee_name" placeholder="姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="工号：">
              <el-input v-model="employeeData.employee_no" placeholder="工号" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="职位：">
              <el-input v-model="employeeData.position_id" placeholder="职位" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="考勤组：">
              <el-input v-model="employeeData.group_name" placeholder="考勤组" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="部门：">
              <el-input v-model="employeeData.department_name" placeholder="部门" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="考勤月份：">
              <el-input v-model="employeeData.work_month" placeholder="考勤月份" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="申诉时间：">
              <el-input v-model="employeeData.grievance_time" placeholder="部门" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="申诉内容：">
              <el-input type="textarea" v-model="employeeData.grievance_content" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <FrameItem v-model="employeeData.exception_file_id" :file-list="exception_file_id_obj" :item="uploadObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>处理状态：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="150px" :disabled="isShow">
        <el-row>
          <el-col :span="11">
            <el-form-item label="处理状态：" required>
              <el-select v-model="employeeData.handle_status" placeholder="处理状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="二次确认：">
              <el-switch v-model="employeeData.is_twice_confirm" active-text="再次发送考勤信息给员工确认"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="employeeData.handle_remark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <FrameItem v-model="employeeData.handle_file_id" :file-list="handle_file_id_obj" :item="uploadObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="save"  :disabled="isShow">保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "AttendanceException",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    statusList() {
      return this.$store.getters['core/getDictList']('handle_status');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      contractTypeList:[],
      reasonList: [],
      employeeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[],
      exception_file_id_obj:[],
      handle_file_id_obj:[],
      file_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeContract() {
      let params = {id: this.parentData.id}
      this.$http('attendanceSettingService.getExceptionById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.handle_file_id_obj = data.handle_file_id_obj;
          this.exception_file_id_obj = data.exception_file_id_obj;
          this.employeeData = data;
          if(data.handle_status !== "0"){
            this.isShow = true;
          }
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    async getEmployee(){
      this.employeeList =await this.$http('employeeArchivesService.getDepartmentAndEmpId');
    },
    //获取员工
    async getContractType(){
      this.contractTypeList =await this.$http('employeeArchivesService.getContractInfo');
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    save() {
      console.log(this.employeeData.handle_status);
      this.loading = true;
      this.$http('attendanceSettingService.updateAttendanceExceptionHandle', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.file_id = ids;
    },
  },
  created() {
    this.getContractType();
    this.getEmployee();
    this.loadEmployeeContract();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>